import api from './api';

/**
 * Rail/terminal reference data for the Pro Detail "Terminal" dropdown.
 *
 * `terminal` is the carrier code stored in orderscurrent.rail (e.g.
 * `SAV-GCT`, `HOU-BCT`, `BNSF`). `terminalType` is the V1-defined
 * category that drives the mode/terminal compatibility check on save:
 *   - `PORT` — Mode must be AWR
 *   - `RAIL` — Mode must be MLB
 *   - `OTHER` — no compatibility constraint
 *
 * The list is small (a few dozen rows) and effectively static within a
 * session, so we cache the response in module scope to avoid duplicate
 * fetches across pro-detail mounts.
 */

export interface RailOption {
  terminal: string;
  terminalType: string;
}

let railsCache: Promise<RailOption[]> | null = null;

export async function getRails(): Promise<RailOption[]> {
  if (!railsCache) {
    railsCache = api
      .get<RailOption[]>('/admin/rails')
      .then((r) => r.data)
      .catch((err) => {
        // Reset on failure so a retry isn't permanently poisoned.
        railsCache = null;
        throw err;
      });
  }
  return railsCache;
}

/** Drops the in-memory cache. Mostly useful for tests. */
export function clearRailsCache(): void {
  railsCache = null;
}
